window.addEventListener("DOMContentLoaded", (event) => {
  const divOverlay = document.querySelector('#page-transition-overlay');
  setTimeout(() => {
    divOverlay.classList.add('hidden--custom');
  }, 1000);
});
/*-----------------------------------------------*/
const data_productJSON = document.querySelector('[data-variant-json]');
let first_update = true;
if(Boolean(data_productJSON)){
  const productJSON = JSON.parse(data_productJSON.innerHTML);
  const btnKlaviyo = document.querySelector('.klaviyo-bis-trigger.btn');
  const variantItems = document.querySelectorAll('.product__controls-group .product__chip');
  variantItems.forEach((item,index) => {
    /*if (index == 0) {
      is_availableItem(productJSON,variantItems[0]);
    }
    if (first_update == true) {
      first_update = false;
      is_availableItem(productJSON,item);
    }
    item.addEventListener("click",e=>{      
      is_availableItem(productJSON,item);
    });*/
    item.addEventListener("click",e=>{
      let getVariant = productJSON.find(variant => variant.public_title.toLowerCase() === item.dataset.optionValue.toLowerCase());
      if(Boolean(getVariant)){
        let getquant = parseInt(document.querySelector(`#variant-selector option[value="${getVariant.id}"]`).dataset.qty);
        let getavailable = document.querySelector(`#variant-selector option[value="${getVariant.id}"]`).dataset.available;
        (getquant<=0)?preventFunc(getavailable):defaultPrevent(getavailable);
      }
      if (item.classList.contains('disabled') == false) {            
        btnKlaviyo.style.display = 'none';
      }else{
        btnKlaviyo.style.display = 'flex';
      }
    });   
  });
}

function is_availableItem(productJSON, item) {
  let getVariant = productJSON.find(variant => variant.public_title.toLowerCase() === item.dataset.optionValue.toLowerCase());
  if(Boolean(getVariant)){
    let getquant = parseInt(document.querySelector(`#variant-selector option[value="${getVariant.id}"]`).dataset.qty);
    let getavailable = document.querySelector(`#variant-selector option[value="${getVariant.id}"]`).dataset.available;
    (getquant<=0)?preventFunc(getavailable):defaultPrevent(getavailable);
  }  
}

function preventFunc(available) {
  //insertemoas el input
  //alert("insert input");
  let preOrderbtn_txt = document.querySelector('.product-form__cart-submit[name="add"] span'); 
  let variantItems_wrapper = document.querySelector('.product__controls-group');  
  if (available == "true") {
    let prForm = document.querySelector('form.product-form');
    let input_preOrder = document.createElement("input");
      input_preOrder.setAttribute("id", "input_preOrder");
      input_preOrder.setAttribute("type", "hidden");
      input_preOrder.setAttribute("name", "properties[PRE ORDER]");
      input_preOrder.setAttribute("value", "Si");
  
    let input_timeOrder = document.createElement("input");  
      input_timeOrder.setAttribute("id", "input_timeOrder");
      input_timeOrder.setAttribute("type", "hidden");
      input_timeOrder.setAttribute("name", "properties[Tiempo de espera]");
      input_timeOrder.setAttribute("value", variantItems_wrapper.dataset.timeorder);  
    
      prForm.appendChild(input_preOrder);    
      prForm.appendChild(input_timeOrder);  
  
    if(variantItems_wrapper.classList.contains("pre__order")){
      preOrderbtn_txt.textContent = "PRE ORDER";
    }
  }else{
    preOrderbtn_txt.textContent = "Agotado";
  }
}

function defaultPrevent(available) {
  //eliminamos el input
  //alert("eliminar input");
let preOrderbtn_txt = document.querySelector('.product-form__cart-submit[name="add"] span'); 
let variantItems_wrapper = document.querySelector('.product__controls-group');    
  if (available == "true") {
    let prForm = document.querySelector('form.product-form');
    let input_preOrder = document.querySelector("#input_preOrder");
    let input_timeOrder = document.querySelector("#input_timeOrder");
    if (Boolean(input_preOrder)) {
      prForm.removeChild(input_preOrder);  
    }
    if (Boolean(input_timeOrder)) {
      prForm.removeChild(input_timeOrder);
    }
    if(variantItems_wrapper.classList.contains("pre__order")){
      preOrderbtn_txt.textContent = "Añadir a la cesta";
    }  
  }else{
    preOrderbtn_txt.textContent = "Agotado";
  }
}
/*-----------------------------------------------*/
const observer = new MutationObserver((mutationList) => {
  mutationList.forEach((mutation) => {
    if (mutation.addedNodes.length > 0) {
      if (Boolean(mutation.addedNodes[0].classList) && mutation.addedNodes[0].classList.contains('quick-product')) {
        let array_OptionsModal = document.querySelectorAll('.quick-product--modal__inner .product__option .product__chip.dynamic-variant-button');
        array_OptionsModal.forEach(prodOption=>{
          prodOption.addEventListener('click', (e)=>{
            let btn_addtoCart = document.querySelector(`.quick-product__btn-wrapper .product-form__cart-submit[name="add"]`);
            let btn_text = btn_addtoCart.querySelector(`[data-add-to-cart-text]`);
            if (prodOption.classList.contains('disabled') == false) {            
              btn_text.textContent = `${btn_addtoCart.dataset.langAvailable}`;
              btn_addtoCart.removeAttribute("disabled");
            }else{
              btn_addtoCart.setAttribute("disabled", "disabled");
              btn_text.textContent = `${btn_addtoCart.dataset.langSoldOut}`;
            }
          });
        });
      }else{
        //
      }
    }
  });
});

const targetNode = document.querySelector('.quick-view-modal__content');
const observerOptions = {
  attributes: true,
  childList: true,
  subtree: true
};

observer.observe(targetNode, observerOptions);